import React, { useContext } from 'react';
import { string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ProductHorizontalDesktop } from './product-horizontal-desktop';
import { ProductHorizontalMobile } from './product-horizontal-mobile';
import './product-horizontal.style.scss';

export const ProductHorizontal = ({ channelFromTest }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile' || channelFromTest === 'mobile';

  return (isMobile
    ? <ProductHorizontalMobile channelFromTest={channelFromTest} /> : <ProductHorizontalDesktop />
  );
};

ProductHorizontal.displayName = 'ProductPodHorizontal';

ProductHorizontal.propTypes = {
  channelFromTest: string,
};

ProductHorizontal.defaultProps = {
  channelFromTest: null
};
